import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('varient_code_conversion')
export class SkuCodesDetail {
    @PrimaryGeneratedColumn("increment",{name:'sku_codes_detail_Id'})
    skuCodeDetailId:number;
    @Column("int",{
        nullable:false,
        name:"sku_code_id"
        })
        skuCodeId:number;

            @Column("int",
            {
                nullable: false,
                name :"conversion_code_id"
            })
            multipleVarientCode :number;

@CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "created_user",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
    static multipleVarientCode: any;
}